import React from "react";

export default function WizardProgress({

    step,

    total

}) {

    const steps = [

        "Brand",
        "Business",
        "Story",
        "Preferences",
        "Finish"

    ];

    return (

        <div>

            {/* Progress Bar */}

            <div
                style={{
                    height: 8,
                    background: "#ececec",
                    borderRadius: 999,
                    overflow: "hidden"
                }}
            >

                <div
                    style={{
                        width: `${((step - 1) / (total - 1)) * 100}%`,
                        height: "100%",
                        background:
                            "linear-gradient(90deg,#4F46E5,#7C3AED)",
                        transition: ".35s"
                    }}
                />

            </div>

            {/* Step Numbers */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 14
                }}
            >

                {steps.map((label, index) => {

                    const current = index + 1;

                    const completed =
                        current < step;

                    const active =
                        current === step;

                    return (

                        <div
                            key={label}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                flex: 1
                            }}
                        >

                            <div
                                style={{

                                    width: 34,

                                    height: 34,

                                    borderRadius: "50%",

                                    display: "flex",

                                    alignItems: "center",

                                    justifyContent: "center",

                                    fontWeight: 600,

                                    transition: ".3s",

                                    background: completed

                                        ? "#22C55E"

                                        : active

                                        ? "#4F46E5"

                                        : "#ECECEC",

                                    color:

                                        completed ||

                                        active

                                            ? "#fff"

                                            : "#666"

                                }}
                            >

                                {completed

                                    ? "?"

                                    : current}

                            </div>

                            <div
                                style={{
                                    marginTop: 8,
                                    fontSize: 13,
                                    fontWeight: active
                                        ? 600
                                        : 400,
                                    color: active
                                        ? "#4F46E5"
                                        : "#777",
                                    textAlign: "center"
                                }}
                            >

                                {label}

                            </div>

                        </div>

                    );

                })}

            </div>

        </div>

    );

}